function modal(id) {
    if (id.length) {
        id.bPopup({
            positionStyle: 'fixed',
            easing: 'easeOutBack',
            speed: 350,
            opacity: .75,
            appending: true,
            appendTo: '.website-wrapper',
            modalColor: '#eef2ff',
            onOpen: function() {
                var window = $('#_workarea').width();
                setTimeout(function(){
                    $('.website-wrapper').addClass('_no-scroll').css('max-width', window);
                }, 400);
            },
            onClose: function() {
                $('.website-wrapper').removeClass('_no-scroll').css('max-width', '');
            }
        });
    }

}